import Vue from 'vue'
export default {
  namespaced: true,
  state: () => ({
    patient_id: null,
    doctor_id: null,
    items: []
  }),
  getters: {
    patient_id: state => state.patient_id,
    doctor_id: state => state.doctor_id,
    items: state => state.items
  },
  mutations: {
    set (state, panels) {
      panels.sort((a, b) => {
        if (a.date < b.date) {
          return 1
        }
        if (a.date > b.date) {
          return -1
        }
        return 0
      })
      state.items = panels
    },
    push (state, { id, title, component, date }) {
      for (const v of state.items) {
        if (v.id === id) {
          return
        }
      }
      state.items.push({
        id: id,
        title: title,
        component: component,
        date: date
      })
      state.items.sort((a, b) => {
        if (a.date < b.date) {
          return 1
        }
        if (a.date > b.date) {
          return -1
        }
        return 0
      })
    },
    reset (state) {
      Vue.set(state, 'items', [])
      state.patient_id = null
      state.doctor_id = null
    },
    setpatient_id (state, patient_id) {
      state.patient_id = patient_id
    },
    setdoctor_id (state, doctor_id) {
      state.doctor_id = doctor_id
    },
    setComponent (state, { id, component }) {
      for (const i in state.items) {
        if (state.items[i].id === id) {
          Vue.set(state.items[i], 'component', component)
        }
      }
    },
    remove (state, id) {
      for (const i in state.items) {
        if (state.items[i].id === id) {
          state.items.splice(i, 1)
        }
      }
    }
  }
}
